import CheckboxGroupInput, { CheckboxProps } from './CheckboxGroupInput'
import styles from './styles.module.scss'

type CheckboxField = CheckboxProps

type CheckboxGroupProps = {
  classes?: string
  fields: CheckboxField[]
  onChange: (arg: CheckboxField[]) => void
}

function CheckboxGroup({ classes, fields, onChange }: CheckboxGroupProps) {
  const handleOnChange = (checkboxProps: CheckboxProps) => {
    const newFields = fields.map(field =>
      field.id === checkboxProps.id
        ? { ...field, isChecked: checkboxProps.isChecked }
        : field
    )
    onChange(newFields)
  }

  return (
    <div className={`${styles.checkboxGroup} ${classes}`}>
      {fields.map(checkboxProps => (
        <CheckboxGroupInput
          key={checkboxProps.label}
          isChecked={checkboxProps.isChecked}
          value={checkboxProps.value}
          label={checkboxProps.label}
          id={checkboxProps.id}
          onChange={handleOnChange}
        />
      ))}
    </div>
  )
}

export default CheckboxGroup
